var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCumulativeArrowTopLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "264px",
    height: "265px",
    viewBox: "0 0 264 265",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow53") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pixagri",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Aide-11-bis",
    transform: "translate(-319.000000, -163.000000)",
    stroke: "#9EBE4A",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow53",
    transform: "translate(451.252021, 295.454706) scale(-1, 1) rotate(-26.000000) translate(-451.252021, -295.454706) translate(355.468499, 198.457880)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line-21",
    strokeLinejoin: "round",
    transform: "translate(3.387720, 120.725439) rotate(-183.000000) translate(-3.387720, -120.725439) ",
    points: "0.166355801 117.462471 6.397721 117.509293 6.60908432 123.988407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1246786,24.3794287 C31.4217674,41.2041225 23.0824961,109.122037 50.6341073,143.748173 C69.001848,166.832264 106.359988,174.465352 162.708526,166.647436",
    id: "Line-8",
    transform: "translate(96.435729, 96.996826) scale(1, -1) rotate(-33.000000) translate(-96.435729, -96.996826) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCumulativeArrowTopLeft);
export default __webpack_public_path__ + "static/media/cumulative_arrow_top_left.06bad0e6.svg";
export { ForwardRef as ReactComponent };